<template>
  <div :class="['comment', { 'element--is-loading': loading }]">
    <div v-if="!useEditMode" class="comment__readonly">
      {{ initialValue }}
    </div>

    <template v-else>
      <button v-show="isEmpty(comment) && !commentIsActive" class="comment__trigger" @click.prevent="setCommentIsActive(true)">
        {{ title }}
      </button>

      <input
        v-show="!isEmpty(comment) && !commentIsActive"
        v-model="comment"
        :placeholder="title"
        class="comment__input"
        @focus="setCommentIsActive(true)">

      <textarea
        v-show="commentIsActive"
        ref="comment"
        v-model="comment"
        :placeholder="title"
        class="comment__input comment__input--is-active"
        @keydown.enter.prevent="saveComment()"></textarea>

      <div class="comment__actions">
        <div class="comment__actions-left">
          <button
            v-if="commentIsActive"
            class="comment__action"
            :disabled="!changed"
            @click.prevent="saveComment()">
            {{ tStatic('headerCartNoteSaveLabel') }}
          </button>

          <div v-if="commentIsActive" class="comment__action-seperator">
            |
          </div>

          <button
            v-if="commentIsActive || !isEmpty(comment)"
            :disabled="isEmpty(comment)"
            class="comment__action"
            @click.prevent="deleteComment()">
            {{ tStatic('headerCartNoteDeleteLabel') }}
          </button>
        </div>

        <button v-if="commentIsActive" class="comment__action comment__action--close" @click.prevent="hideComment()">
          {{ tStatic('headerCartNoteCloseLabel') }}
        </button>
      </div>
    </template>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  props: {
    title: {
      type: String,
      required: true
    },
    initialValue: {
      type: String,
      default: ''
    },
    useEditMode: {
      type: Boolean,
      default: true
    }
  },

  data: () => ({
    commentIsActive: false,
    comment: '',
    lastSaved: '',
    loading: false
  }),

  computed: {
    changed: function() {
      return this.comment !== this.lastSaved
    }
  },

  watch: {
    initalValue: function(val) {
      this.comment = val
      this.lastSaved = val
    }
  },

  mounted() {
    this.comment = this.initialValue
    this.lastSaved = this.initialValue
  },

  methods: {
    setCommentIsActive(val) {
      this.commentIsActive = val

      if (this.commentIsActive) {
        this.$nextTick(() => {
          this.$refs.comment.focus()
        })
      }
    },

    saveComment() {
      this.loading = true
      this.$emit('save', this.comment, {
        success: () => {
          this.setCommentIsActive(false)
          this.lastSaved = this.comment
          this.loading = false
        },
        error: () => {
          this.loading = false
        }
      })
    },

    deleteComment() {
      this.loading = true
      this.$emit('delete', {
        success: () => {
          this.setCommentIsActive(false)
          this.lastSaved = ''
          this.comment = ''
          this.loading = false
        },
        error: () => {
          this.loading = false
        }
      })
    },

    hideComment() {
      this.setCommentIsActive(false)
    },

    isEmpty(val) {
      return _.isEmpty(val)
    }
  }
}
</script>

<style lang="scss">
.comment {
  width: 100%;
}

.comment__trigger {
  @include reset-button;
  padding: 0;
  color: color(text-blue);

  &:hover {
    text-decoration: underline;
  }
}

.comment__input {
  @include body;
  width: 100%;
  margin-bottom: measure(eighth);
  padding: measure(quarter);
  background-color: #FAFAFA;
  border: 1px solid color(border-gray);
  border-radius: 3px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  resize: none;
}

.comment__input--is-active {
  @include body;
  height: 5.75rem;
  white-space: initial;
  text-overflow: initial;
  resize: none;
}

.comment__input--has-comment {
  margin-bottom: measure(eighth);
}

.comment__actions {
  display: flex;
  justify-content: space-between;
}

.comment__actions-left {
  display: flex;
}

.comment__action {
  @include reset-button;
  @include body-smaller;

  &:hover {
    text-decoration: underline;
  }
}

.comment__action:disabled {
  pointer-events: none;
}

.comment__action--close {
  margin-left: auto;
}

.comment__action-seperator {
  margin: 0 measure(quarter);
}
</style>
